import { createReducer, on } from '@ngrx/store';

import { initialVatsState, IVatsState, TVat } from './vats.state';
import { VatsLoaded } from './vats.actions';

export const initialState: IVatsState = {
  vatsInfo: [],
};

const setVats = (state: IVatsState, { vatsInfo }: { vatsInfo: TVat[] }) => {
  return ({
    ...state,
    vatsInfo
  })};


const _vatsReducer = createReducer<IVatsState>(
  initialVatsState,
  on(VatsLoaded, setVats)
);

export function vatsReducer(state: IVatsState, action): IVatsState {
  return _vatsReducer(state, action);
}
